export default {
  namespaced: true,

  state: () => ({
    faqCategories: {
      data: [],
      links: {},
      meta: {},
    },
    faqCategory: {},
    isLoading: false,
  }),

  getters: {},

  mutations: {
    SET_FAQ_CATEGORIES_LIST(state, payload) {
      state.faqCategories = payload
    },
    SET_FAQ_CATEGORIES(state, payload) {
      state.faqCategory = payload
    },
    SET_LOADING(state, value) {
      state.isLoading = value
    },
  },

  actions: {
    async getCategoriesFaq({ commit }, { page = null, keyword = '' } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = `/v1/admin/faqs/categories?filter[name]=${keyword}`

        const response = await this._vm.$http.get(url, { params: { page } })

        commit('SET_FAQ_CATEGORIES_LIST', response.data)

        commit('SET_LOADING', false)
        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
        commit('SET_LOADING', false)
        return error
      }
    },
    async deleteCategoriesFaq({ commit, dispatch }, { faqCategoryId }) {
      try {
        const url = `/v1/admin/faqs/categories/${faqCategoryId}`

        const response = await this._vm.$http.delete(url)

        dispatch('getCategoriesFaq')

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menghapus Kategori FAQ!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menghapus Kategori FAQ!',
        }, { root: true })

        return error
      }
    },
    async createCategoriesFaq({ commit }, data) {
      try {
        const url = '/v1/admin/faqs/categories'
        const response = await this._vm.$http.post(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Kategori FAQ!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Kategori FAQ!',
        }, { root: true })

        return error
      }
    },
    async getCategoryFaq({ commit }, { id }) {
      try {
        const url = `/v1/admin/faqs/categories/${id}`

        const response = await this._vm.$http.get(url)

        commit('SET_FAQ_CATEGORIES', response.data)

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
        return error
      }
    },
    async updateCategoryFaq({ commit }, { faqCategoryId, data }) {
      try {
        const url = `/v1/admin/faqs/categories/${faqCategoryId}`
        const response = await this._vm.$http.put(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Kategori FAQ!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Kategori FAQ!',
        }, { root: true })

        return error
      }
    },
  },
}
